import React, { Fragment, useEffect, useState } from "react";
import PropTypes from "prop-types";
import DataList from "./DataList";
import openInNewTab from "../utils/open-in-new-tab";
import dateToDutchString from "../utils/date-to-dutch-string";
import ActionHelper from "../helpers/ActionHelper";
import { Button, Dialog, DialogTitle } from "@material-ui/core";
import SetExpirationDateForFileForm from "./forms/SetExpirationDateForFileForm";
import AttachFileIcon from "@material-ui/icons/AttachFile";

const credentials = JSON.parse(localStorage.getItem("credentials"));

const FilesList = (props) => {
  const [data, setData] = useState([]);
  const [isFetching, setIsFetching] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");

  const [isDialogOpen, setIsDialogOpen] = useState(false);

  const [selectedFileId, setSelectedFileId] = useState("");

  useEffect(() => loadData(), []);

  const loadData = async () => {
    try {
      setIsFetching(true);
      const files = (await props.loadData()) || [];
      const now = new Date();
      const data = files.map((f) => {
        const isFileExpired = new Date(f.expirationDate) < now;
        return {
          id: f.id,
          title: f.name,
          subtitle: `Aangemaakt op: ${dateToDutchString(f.createdAt)} ${
            f.expirationDate
              ? `| ${isFileExpired ? "Vervallen" : "Vervalt"} op: ` +
                dateToDutchString(f.expirationDate)
              : ""
          }`,
          onClick: () =>
            openInNewTab(`${process.env.REACT_APP_API.trim()}/file/${f.id}`),
          ctxMenu: [
            {
              label: "Vervaldatum instellen",
              action: () => {
                setSelectedFileId(f.id);
                setIsDialogOpen(true);
              },
              hide: !credentials.user.isAdmin,
            },
            {
              label: "Verwijderen",
              action: () => deleteFile(f.id),
              confirm: true,
              hide: !credentials.user.isAdmin,
            },
          ],
        };
      });
      setData(data);
    } finally {
      setIsFetching(false);
    }
  };

  const onFileSelected = (e) => {
    const reader = new FileReader();
    reader.readAsDataURL(e.target.files[0]);
    const filename = e.target.files[0].name;

    reader.onload = async function () {
      try {
        const body = {
          filename,
          file: reader.result,
        };
        await ActionHelper.requestServer(
          "POST",
          props.fileUploadEndpoint,
          body,
        );
        setSuccessMessage("Bestand uploaden voltooid.");
        await loadData();
      } catch (error) {
        setErrorMessage("Bestand uploaden gefaald.");
      }
    }.bind(this);
  };

  const deleteFile = async (fileId) => {
    try {
      setIsFetching(true);
      await ActionHelper.requestServer("DELETE", `/file/${fileId}`);
      setSuccessMessage("Bestand verwijderen voltooid.");
      loadData();
    } catch (err) {
      setErrorMessage(err);
    } finally {
      setIsFetching(false);
    }
  };

  return (
    <Fragment>
      <div>
        <input
          id="file"
          type="file"
          onChange={onFileSelected}
          style={{ display: "none" }}
        />
        <label htmlFor="file">
          <Button variant="contained" color="primary" component="span">
            <AttachFileIcon />
            Upload bestand
          </Button>
        </label>
      </div>
      <DataList
        data={data}
        isFetching={isFetching}
        successMessage={successMessage}
        errorMessage={errorMessage}
      />
      <Dialog open={isDialogOpen} onClose={() => setIsDialogOpen(false)}>
        <DialogTitle id="dialog-set-expiration-date-for-file">
          Vervaldatum instellen
        </DialogTitle>
        <div style={{ padding: 10 }}>
          <SetExpirationDateForFileForm
            fileId={selectedFileId}
            onSuccess={() => {
              loadData();
              setIsDialogOpen(false);
            }}
          />
        </div>
      </Dialog>
    </Fragment>
  );
};

FilesList.propTypes = {
  fileUploadEndpoint: PropTypes.string.isRequired,
  loadData: PropTypes.func.isRequired,
};

export default FilesList;



// WEBPACK FOOTER //
// ./src/components/FilesList.js